import styles from './StageInfoModal.module.css';

import QualityControlIcon from 'assets/svg/quality-control-01.svg';

import { address_server_short, PUBLIC_ASSETS } from 'config';
import { SchemeNodeTypes } from 'consts/scheme.consts';
import Icon from 'ui/Icon';
import ProgressArrow from 'ui/ProgressArrow';

const ObjectsInfo = ({ objects, childrenArray, node }) => {
  const type = node?.type;
  const children = childrenArray
    ?.filter((item) => item.type !== SchemeNodeTypes.qualityControl)
    ?.reduce((acc, parent) => {
      return acc.concat(parent.objects || []);
    }, []);

  return (
    <div className={styles.icon}>
      {objects?.map((obj, index) => (
        <div className={styles.wrapperIcon} key={index}>
          <div className={styles.iconContainer}>
            <Icon width={30} height={30} src={address_server_short + PUBLIC_ASSETS + obj.image} />
          </div>
          <span className={styles.textMain}>{obj.name}</span>
          {(obj.value?.id_general || obj.value?.id) && (
            <span className={styles.textMain} style={{ fontWeight: 'bold' }}>
              {'ID:' + (obj.value?.id_general || obj.value?.id)}
            </span>
          )}
          <div>
            <span className={styles.textMain}>{obj.value?.volume?.amount}</span>
            {obj.value?.volume?.unit_name && (
              <span className={styles.textMain}>({obj.value?.volume?.unit_name})</span>
            )}
          </div>
        </div>
      ))}
      <ProgressArrow />
      <div
        style={{
          display: 'flex',
          gap: '0.125rem',
        }}
      >
        {type === SchemeNodeTypes.sample
          ? children?.map((item, index) => (
              <div className={styles.wrapperIcon} key={index}>
                <div className={styles.iconContainer}>
                  <Icon
                    width={30}
                    height={30}
                    src={address_server_short + PUBLIC_ASSETS + item.image}
                  />
                </div>
                <span className={styles.textMain}>{item.name}</span>
                {(item.value?.id_general || item.value?.id) && (
                  <span className={styles.textMain} style={{ fontWeight: 'bold' }}>
                    {'ID:' + (item.value?.id_general || item.value?.id)}
                  </span>
                )}
                <div>
                  <span className={styles.textMain}>{item.value?.volume?.amount}</span>
                  {item.value?.volume?.unit_name && (
                    <span className={styles.textMain}>({item.value?.volume?.unit_name})</span>
                  )}
                </div>
              </div>
            ))
          : type === SchemeNodeTypes.qualityControl && (
              <div className={styles.wrapperIcon}>
                <div className={styles.iconContainer}>
                  <Icon width={30} height={30} src={QualityControlIcon} />
                </div>
                <span className={styles.textMain}>{node.name}</span>
                {node.id && (
                  <span className={styles.textMain} style={{ fontWeight: 'bold' }}>
                    {'ID:' + node.id}
                  </span>
                )}
              </div>
            )}
      </div>
    </div>
  );
};

export default ObjectsInfo;
